<template>
    <div
        class="w-full bg-cover bg-center px-4 lg:px-0 py-12 bg-abs-white"
        :style="containerStyles"
        v-observe-visibility="visibilityChanged"
    >
        <div class="flex justify-center">
            <div class="container flex justify-end">
                <div class="p-4 p-0 w-full md:w-2/5">
                    <h3 class="text-3xl font-sans-lato font-light mb-4">
                        {{ devise.title.text }}
                    </h3>
                    <div v-html="devise.description.text"></div>
                    <div class="flex justify-between">
                        <div class="text-center" v-if="devise.restaurants.text">
                            <div
                                class="text-collection-teal font-serif-times font-bold"
                                style="font-size: 92px"
                            >
                                {{ counters.numberOfRestaurants }}
                            </div>
                            <div class="pb-2 px-4 w-full flex justify-center">
                                <div
                                    class="border-b border-grey-dark"
                                    style="width: 40px"
                                ></div>
                            </div>
                            <div
                                class="text-xs uppercase font-thin leading-loose opacity-0 restaurant-label"
                            >
                                Restaurants
                            </div>
                        </div>
                        <div class="text-center" v-if="devise.bars.text">
                            <div
                                class="text-collection-teal font-serif-times font-bold"
                                style="font-size: 92px"
                            >
                                {{ counters.numberOfBars }}
                            </div>
                            <div class="pb-2 px-4 w-full flex justify-center">
                                <div
                                    class="border-b border-grey-dark"
                                    style="width: 40px"
                                ></div>
                            </div>
                            <div
                                class="text-xs uppercase font-thin leading-loose opacity-0 bars-label"
                            >
                                Bars
                            </div>
                        </div>
                        <div class="text-center" v-if="devise.lounges.text">
                            <div
                                class="text-collection-teal font-serif-times font-bold"
                                style="font-size: 92px"
                            >
                                {{ counters.numberOfLounges }}
                            </div>
                            <div class="pb-2 px-4 w-full flex justify-center">
                                <div
                                    class="border-b border-grey-dark"
                                    style="width: 40px"
                                ></div>
                            </div>
                            <div
                                class="text-xs uppercase font-thin leading-loose opacity-0 lounges-label"
                            >
                                Lounges
                            </div>
                        </div>
                    </div>
                    <div
                        class="pt-8 text-sm"
                        style="columns: 2; column-gap: 30px"
                        v-html="devise.includedItems.text"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';

export default {
    data() {
        return {
            animationDuration: 1500,
            counters: {
                numberOfRestaurants: 0,
                numberOfBars: 0,
                numberOfLounges: 0,
            },
        };
    },
    computed: {
        containerStyles() {
            let styles = {
                'background-image': "url('" + this.devise.image.url + "')",
            };
            if (this.breakpoint !== 'mobile') {
                return styles;
            }

            return {};
        },
    },
    methods: {
        visibilityChanged(isVisible) {
            if (isVisible) {
                anime({
                    targets: this.counters,
                    numberOfRestaurants: this.devise.restaurants.text,
                    round: 1,
                    duration: this.animationDuration,
                    easing: 'linear',
                });
                anime({
                    targets: this.counters,
                    numberOfBars: this.devise.bars.text,
                    round: 1,
                    duration: this.animationDuration,
                    delay: this.animationDuration,
                    easing: 'linear',
                });
                anime({
                    targets: this.counters,
                    numberOfLounges: this.devise.lounges.text,
                    round: 1,
                    duration: this.animationDuration,
                    delay: this.animationDuration * 2,
                    easing: 'linear',
                });
                anime({
                    targets: [
                        '.restaurant-label',
                        '.bars-label',
                        '.lounges-label',
                    ],
                    opacity: 1,
                    duration: 3000,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(this.animationDuration),
                });
            }
        },
    },
};
</script>
